{
  "billing": {
    "cartCleared": "Cart cleared",
    "discountApplied": "Discount applied",
    "lineDiscountUpdated": "Line discount updated",
    "billHeld": "Bill held",
    "approvedRetry": "Approved — retry the action"
  },
  "toast": {
    "billLoadedCompleteAtBilling": "Bill loaded — complete at billing",
    "heldBillCancelled": "Held bill cancelled",
    "heldBillLoaded": "Held bill loaded",
    "saleSavedOfflineWillSyncWhenConnectionReturns": "Sale saved offline — will sync when connection returns",
    "scaleDisconnected": "Scale disconnected",
    "labelPrinterReadyUseSystemPrintDialog": "Label printer ready — use system print dialog",
    "labelPrinterDisconnected": "Label printer disconnected",
    "receiptPrinterReadyUseSystemPrintDialog": "Receipt printer ready — use system print dialog",
    "receiptPrinterDisconnected": "Receipt printer disconnected",
    "cashDrawerKickSent": "Cash drawer kick sent",
    "gatewaySaved": "Gateway saved",
    "counterCreated": "Counter created",
    "modifiersSaved": "Modifiers saved",
    "shiftClosedSuccessfully": "Shift closed successfully",
    "shiftOpened": "Shift opened",
    "approvedRetryTheAction": "Approved — retry the action",
    "offlineQueueSynced": "Offline queue synced",
    "hardwareConfigSaved": "Hardware config saved",
    "customerAdded": "Customer added",
    "couponApplied": "Coupon {{code}} applied",
    "returnProcessedSuccess": "{{type}} processed successfully",
    "scaleConnected": "Scale connected: {{label}}",
    "labelPrinterConnected": "Label printer connected: {{label}}",
    "receiptPrinterConnected": "Receipt printer connected: {{label}}",
    "promotionDiscountApplied": "Promotion discount {{amount}} applied",
    "invoiceCreated": "Invoice {{invoiceNumber}} created",
    "offlineSaleSynced": "Synced offline sale {{invoiceNumber}}",
    "workingInStore": "Working in {{store}}"
  },
  "errors": {
    "invalidHeldBillData": "Invalid held bill data",
    "failedToLoadHeldBills": "Failed to load held bills",
    "resumeFailed": "Resume failed",
    "cancelFailed": "Cancel failed",
    "selectABillingCounterBeforePayment": "Select a billing counter before payment",
    "selectARegisteredCustomerForWalletPayment": "Select a registered customer for wallet payment",
    "selectACreditEnabledCustomer": "Select a credit-enabled customer",
    "customerIsNotEnabledForCreditSales": "Customer is not enabled for credit sales",
    "insufficientPayment": "Insufficient payment",
    "openShiftBeforePayment": "Open a cashier shift before taking payment",
    "paymentCancelledInvoiceSavedAsPending": "Payment cancelled — invoice saved as pending",
    "splitPaymentRequiresAtLeastTwoTenders": "Split payment requires at least two tenders",
    "invalidOrExpiredCoupon": "Invalid or expired coupon",
    "gatewayPaymentFailed": "Gateway payment failed",
    "couldNotQueueOfflineSale": "Could not queue offline sale",
    "checkoutFailed": "Checkout failed",
    "offlineSaleRejectedByServer": "Offline sale rejected by server",
    "invoiceNotFoundForThisStore": "Invoice not found for this store",
    "supervisorApprovalRequired": "Supervisor approval required",
    "failedToSaveGateway": "Failed to save gateway",
    "failedToCreateCounter": "Failed to create counter",
    "failedToCloseShift": "Failed to close shift",
    "failedToOpenShift": "Failed to open shift",
    "holdFailed": "Hold failed",
    "requestRejected": "Request rejected",
    "failedToLoadApproval": "Failed to load approval",
    "approvalFailed": "Approval failed",
    "selectARegisteredCustomerForWallet": "Select a registered customer for wallet",
    "selectAProductFirst": "Select a product first",
    "labelPrintFailed": "Label print failed",
    "failedToSaveHardwareConfig": "Failed to save hardware config",
    "openBillingTerminalFirstToCreateADisplay": "Open billing terminal first to create a display session",
    "phoneNumberIsRequired": "Phone number is required",
    "couldNotCreateCustomer": "Could not create customer",
    "insufficientWalletBalance": "Insufficient wallet balance ({{balance}} available)",
    "insufficientCredit": "Insufficient credit ({{available}} available)",
    "insufficientLoyaltyPoints": "Insufficient loyalty points ({{balance}} available)",
    "splitPaymentsMustEqualTotal": "Split payments ({{sum}}) must equal total {{total}}"
  },
  "pages": {
    "payment": "Payment",
    "billDiscount": "Bill discount",
    "quantity": "Quantity",
    "printBarcodeLabel": "Print barcode label",
    "weighingScale": "Weighing scale",
    "barcodeLabelPrinter": "Barcode / label printer",
    "thermalReceiptPrinter": "Thermal receipt printer",
    "cashDrawer": "Cash drawer",
    "customerDisplay": "Customer display",
    "barcodeScanner": "Barcode scanner",
    "quickAddCustomer": "Quick add customer",
    "navigateEnterResumeEscBackTo": "↑↓ navigate · Enter resume · Esc back to billing",
    "posAnalytics": "POS Analytics",
    "totalSales": "Total sales",
    "transactions": "Transactions",
    "avgBasket": "Avg basket",
    "topProduct": "Top product",
    "posTerminalReports": "POS Terminal Reports",
    "noPosActivity": "No POS activity",
    "adjustTheDateRangeOrComplete": "Adjust the date range or complete sales at the terminal.",
    "returnsExchanges": "Returns & Exchanges",
    "returnRequiresApproval": "Return requires approval",
    "processCustomerReturnsOrExchanges": "Process customer returns or exchanges",
    "posSetup": "POS Setup",
    "noTaxConfiguration": "No tax configuration",
    "shiftManagement": "Shift Management",
    "selectAStoreFirst": "Select a store first",
    "noBillingCountersYet": "No billing counters yet",
    "selectABillingCounter": "Select a billing counter",
    "chooseYourStoreFromThePos": "Choose your store from the POS dashboard, then return here to open or close a shift.",
    "useTheCounterDropdownInThe": "Use the Counter dropdown in the top bar (next to your name), then come back to open or close your shift.",
    "heldBillsForStore": "Held bills — {{store}}"
  },
  "shift": {
    "counterNumber": "Counter #{{id}}",
    "openNewShift": "Open a New Shift",
    "openShiftInfo": "Opening a shift registers your starting cash and ties all transactions to this session for end-of-day reconciliation.",
    "openShift": "🟢 Open Shift",
    "closeShift": "Close Shift",
    "shiftOpened": "Shift opened",
    "byEmployee": "by {{name}}",
    "cashDiscrepancy": "Cash discrepancy",
    "shortCash": "⚠ Short — cash missing from drawer",
    "overCash": "⚠ Over — more cash than expected",
    "status": {
      "OPEN": "Open",
      "ACTIVE": "Active",
      "CLOSED": "Closed"
    },
    "metrics": {
      "openingCash": "Opening cash",
      "cashSales": "Cash sales",
      "expected": "Expected",
      "totalSales": "Total Sales",
      "transactions": "Transactions",
      "returns": "Returns",
      "cardSales": "Card Sales",
      "upiSales": "UPI Sales"
    }
  },
  "statusBar": {
    "barcodeScanner": "Barcode scanner (USB HID)",
    "weighingScale": "Weighing scale",
    "labelPrinter": "Label printer",
    "receiptPrinter": "Receipt printer",
    "customerDisplay": "Customer display"
  },
  "terminalNav": {
    "billing": "Billing",
    "held": "Held",
    "shift": "Shift",
    "returns": "Returns",
    "analytics": "Analytics",
    "setup": "Setup",
    "dashboard": "Dashboard",
    "terminal": "{{module}} terminal",
    "toggleTheme": "Toggle theme"
  },
  "heldBills": {
    "cancelTitle": "Cancel held bill?",
    "cancelMessage": "Release stock reservation for {{reference}}? This cannot be undone.",
    "holdNumber": "Hold #{{id}}",
    "loading": "Loading…",
    "empty": "No held bills. Press Esc to return to billing.",
    "enterResume": "Enter → Resume",
    "footerShortcuts": "Enter open · Esc billing ·",
    "shortcuts": {
      "backToBilling": "Back to billing",
      "resumeBill": "Resume bill",
      "navigation": "Navigation",
      "holdBills": "Hold Bills"
    }
  },
  "paymentMethods": {
    "cash": "Cash",
    "upi": "UPI",
    "card": "Card",
    "wallet": "Wallet",
    "credit": "Credit (account)"
  },
  "labels": {
    "commentsOptional": "Comments (optional)",
    "amount": "Amount",
    "paymentMethodOr14": "Payment method (↑↓ or 1–4)",
    "amountReceived": "Amount received",
    "loyaltyPointsToRedeem1Pt": "Loyalty points to redeem (1 pt = 1 unit off)",
    "billDiscount": "Bill discount",
    "coupon": "Coupon",
    "discountAmount": "Discount amount",
    "quantity": "Quantity",
    "cart": "Cart",
    "item": "Item",
    "qty": "Qty",
    "total": "Total",
    "productSuggestions": "Product suggestions",
    "scanBarcodeOrTypeSkuName": "Scan barcode or type SKU / name",
    "scan": "Scan",
    "scale": "Scale",
    "label": "Label",
    "receipt": "Receipt",
    "display": "Display",
    "selectCounter": "Select counter",
    "searchPhoneNameOrCode": "Search phone, name, or code",
    "phoneNumber": "Phone number *",
    "customerNameOptional": "Customer name (optional)",
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "invoiceIdOrNumber": "Invoice ID or number",
    "reason": "Reason",
    "customerReasonForReturn": "Customer reason for return...",
    "displayName": "Display name",
    "closingCashInDrawer": "Closing cash in drawer",
    "discrepancyReason": "Discrepancy reason",
    "notesOptional": "Notes (optional)",
    "openingCashInDrawer": "Opening cash in drawer",
    "enterAmountCounted": "Enter amount counted",
    "explainTheDiscrepancy": "Explain the discrepancy...",
    "anyShiftNotes": "Any shift notes...",
    "eGFloatFromSafe": "E.g. float from safe",
    "lineDiscount": "Line discount",
    "splitPayment": "Split payment (multiple tenders)",
    "tenderNumber": "Tender {{number}}",
    "splitTotal": "Split total:",
    "walletAvailable": "Wallet: {{amount}} available",
    "creditAvailable": "Credit: {{amount}} available",
    "creditLimit": "limit {{amount}}",
    "gatewayCheckoutAfterInvoice": "Opens {{provider}} checkout after invoice is created.",
    "numberOfLabels": "Number of labels"
  },
  "dialogs": {
    "confirmPayment": "Confirm payment",
    "printLabels": "Print labels"
  },
  "formActions": {
    "cancelBill": "Cancel bill",
    "addToCart": "Add to cart",
    "cancelEsc": "Cancel (Esc)",
    "completeShortcut": "Complete (Enter / Ctrl+Enter)",
    "apply": "Apply",
    "applyEnter": "Apply (Enter)",
    "printLabel": "Print label",
    "multipleCopies": "Multiple copies…"
  },
  "empty": {
    "noProductsTryAnother": "No products — try another code or name",
    "scanOrSearchToAddItems": "Scan or search to add items"
  },
  "hardware": {
    "enabled": "Enabled",
    "connectedWithLabel": "● Connected{{label}}",
    "notConnected": "○ Not connected",
    "testLabelPrint": "Test label print",
    "productId": "Product ID",
    "testPrintFailed": "Test print failed",
    "scaleDescription": "USB/RS-232 scale via Web Serial (Chrome/Edge). Weight auto-fills on the billing screen.",
    "connectScale": "Connect scale",
    "webSerialNotSupported": "Web Serial not supported — use manual weight entry",
    "disconnect": "Disconnect",
    "labelPrinterDescription": "Print product labels from billing (F11 on highlighted product). Uses 50×30 mm label layout.",
    "connectBrowserPrint": "Connect (browser print)",
    "connectUsbSerial": "Connect (USB serial)",
    "testPrint": "Test print",
    "receiptPrinterDescription": "Receipts print automatically after each sale via browser print dialog.",
    "viaReceiptPrinterSerial": "Via receipt printer serial",
    "requiresSerialReceiptPrinter": "Requires serial receipt printer",
    "cashDrawerDescription": "Opens on cash sales when connected to a serial ESC/POS receipt printer.",
    "testDrawerKick": "Test drawer kick",
    "secondScreenWindow": "Second screen / window",
    "customerDisplayDescription": "Opens automatically when billing starts. Shows cart total to the customer on a second monitor or window.",
    "openCustomerDisplay": "Open customer display",
    "usbHidKeyboardMode": "USB HID keyboard mode",
    "scannerDescription": "Plug-and-play — no pairing needed. Scanners act as a keyboard and feed the product search field on the billing screen (F1)."
  }
}
